import { render } from "./fastDaNianPayModel.vue?vue&type=template&id=a5efe6f4"
import script from "./fastDaNianPayModel.vue?vue&type=script&lang=js"
export * from "./fastDaNianPayModel.vue?vue&type=script&lang=js"

import "./fastDaNianPayModel.vue?vue&type=style&index=0&id=a5efe6f4&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__